<router-outlet></router-outlet>
<div id="notification_container"></div>



// WEBPACK FOOTER //
// ./src/app/app.component.html